import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import generateSaleReturnPDF from '../salereturn/Bill';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import AsyncSelect from 'react-select/async';
import ReceiptIcon from '@mui/icons-material/Receipt';
import Modal from '@mui/material/Modal';
import '../shared.css';

const SaleReturnCreate = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL    
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [selectedCardType, setSelectedCardType] = useState("");
    const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);
    const [showCardFields, setShowCardFields] = useState(false);
    const [showupiFields, setShowupiFields] = useState(false);
    const [sbillOptions, setBillOptions] = useState([]);

    const fetchBillOptions = async (inputValue) => {
        if (inputValue.length < 1) {
            return [];
        }

        try {
            const response = await fetchData('PurchaseApi', `/SaleBill/${companyId}/${branchId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setBillOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.BillDetails,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownCardTypeOptions();
        fetchmaxbillno();
        fetchItems();
    }, []);

    const fetchOptions = async (inputValue) => {
        if (inputValue.length < 1) {
            return [];
        }

        const saleid = selectedBillOption?.value ?? 0;
        const saleId = saleid || 0;

        // If saleId is 0, only fetch when inputValue length >= 5
        if (saleId === 0 && inputValue.length < 5) {
            return [];
        }

        const response = await fetchData('PurchaseApi', `/ItemSaleReturn/${companyId}/${saleId}/${inputValue}`, token);
        if (response.responseCode === '1111') {
            const data = await response.response_data;
            return data.map(item => ({
                value: item.Id,
                label: item.Code + '-' + item.Name,
            }));


        }
    };


    const fetchmaxbillno = () => {
        fetchData('SaleReturnApi', `/MaxBillno/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setFormData(prevData => ({
                    ...prevData,
                    BillNumber: data.BillNumber,
                    BillPrefix: data.BillPrefix,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Max Billno', error);
            });
    };

    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleReturnApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    const fetchDropdownCardTypeOptions = () => {
        fetchData('SaleReturnApi', `/CardType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownCardTypeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Card Type dropdown options:', error);
            });
    };

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const [formData, setFormData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        if (name === 'GVAmount') {
            const gvamt = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                GVAmount: gvamt.toFixed(2),
                ModifiedBy: userId,
            }));

            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount);
        }
        else if (name === 'GSTNumber') {
            const gstno = value;
            setFormData((prevData) => ({
                ...prevData,
                GSTNumber: gstno,
                ModifiedBy: userId,
            }));

            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!gstno) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = gstno.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

        }
        else if (name === 'CardAmount') {

            const cardAmount = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                CardAmount: cardAmount.toFixed(2),
                ModifiedBy: userId,
            }));
            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;
            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, cardAmount, UPIAmount);

        }
        else if (name === 'AdditionalDiscountPercentage') {

            const AdditionalDiscountPercentage = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                AdditionalDiscountPercentage: AdditionalDiscountPercentage.toFixed(2),
                ModifiedBy: userId,
            }));
            const AdditionalDisc = parseFloat(AdditionalDiscountPercentage) || 0;
            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });


            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

        }
        else if (name === 'UPIAmount') {

            const upiAmount = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                UPIAmount: upiAmount.toFixed(2),
                ModifiedBy: userId,
            }));
            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;
            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, upiAmount);

        }
        else {

            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
            }));

        }

    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.CustomerName) {
            setErrorMessage('Customer Name is required !');
            setIsLoading(false);
            return;
        }

        // if (!formData.SaleBillNumber) {
        //     setErrorMessage('Sale Bill Number is required !');
        //     setIsLoading(false);
        //     return;
        // }


        // Cash amount validation
        if (formData.CashAmount < 0) {
            setErrorMessage('Cash Amount less than 0 is not allowed!');
            setIsLoading(false);
            return;
        }

        // Card amount validation
        if (formData.CardAmount > 0) {
            if (!formData.CardNumber) {
                setErrorMessage('Card Number is required when Card Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
            if (!selectedCardType) {
                setErrorMessage('Card Type is required when Card Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
        }

        if (!selectedSalesMan) {
            setErrorMessage('Sales Man is required !');
            setIsLoading(false);
            return;
        }

        // Upi amount validation
        if (formData.UPIAmount > 0) {
            if (!formData.UPINumber) {
                setErrorMessage('UPI Number is required when UPI Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
        }


        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
            SalesManId: selectedSalesMan,
            CardType: selectedCardType
        }));

        const CreateData = {
            Sale: formData,
            SaleDetails: invoicedeatils
        };

        // Validate form data here if needed

        postData('SaleReturnApi', CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                // history.push('/SaleReturnIndex');
                history.push('/Home');

                if (response.response === 'Sale Return Create Successfully') {
                    const SaleId = response.kotId;
                    handlePrint(SaleId);
                }

            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const handlePrint = async (SaleId) => {
        try {
            const response = await fetchData('SaleReturnApi', `/SalePrint/${SaleId}/${branchId}`, token);
            generateSaleReturnPDF(response.response_data);
        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...invoicedeatils];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setInvoicedeatils(updatedRecords); // Update the state to reflect the removed record 

            const Quantity = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

        }

    };

    //Items    
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItems, setSelectedItem] = useState("");

    const fetchItems = async () => {
        try {
            const response = await fetchData('SaleReturnApi', `/Item/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {                
                setItemDetails(response.response_data);
            }

            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;

            setFormData(prevData => ({
                ...prevData,
                BillDate: formattedDate,
                BranchId: branchId,
                CompanyId: companyId,
                CreatedBy: userId,
            }));

        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    // FOR MODEL DATA (Invoice Details)
    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemId: '',
        Quantity: '1',
        Rate: '',
        Amount: '',
        DiscountPercentage: '',
        DiscountAmount: '',
        HSNCode: '',
        GSTRate: '',
        TaxableAmount: '',
        CGSTAmount: '',
        SGSTAmount: '',
        IGSTAmount: '',
        TotalAmount: '',
        saleQty: 0,
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemId: '',
            Quantity: '1',
            Rate: '',
            Amount: '',
            DiscountPercentage: '',
            DiscountAmount: '',
            HSNCode: '',
            GSTRate: '',
            TaxableAmount: '',
            CGSTAmount: '',
            SGSTAmount: '',
            IGSTAmount: '',
            TotalAmount: '',
            saleQty: 0,
        });
        setSelectedItem();
        setIsModalOpen(false);
    };

    const saveModalData = () => {
        let isValid = true;
        const saleid = selectedBillOption?.value ?? 0;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }

        if (modalData.Quantity > modalData.saleQty && modalData.saleQty > 0) {
            isValid = false;
            errors = "Quantity exceeds the original sale bill quantity.";
        }

        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...invoicedeatils, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setInvoicedeatils(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName: '',
                ItemId: '',
                Quantity: '1',
                Rate: '',
                Amount: '',
                DiscountPercentage: '',
                DiscountAmount: '',
                HSNCode: '',
                GSTRate: '',
                TaxableAmount: '',
                CGSTAmount: '',
                SGSTAmount: '',
                IGSTAmount: '',
                TotalAmount: '',
                saleQty: 0,
            });

            setSelectedItem(0);
            setSelectedOption(null); // Clear AsyncSelect
            fetchOptions('');
            //closeModal();

            // Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);


        } else {

            console.log("Validation errors:", errors);
            setErrorMessageModel(errors);
        }

    };

    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount) => {

        const gvAmount = parseFloat(gvamt) || 0;

        let netamount = parseFloat(TaxableAmount);
        let netAmt = netamount + parseFloat(CGSTAmount) + parseFloat(SGSTAmount) + parseFloat(IGSTAmount);
        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmt = parseFloat((netAmt + roundOffValue)).toFixed(2);
        totalAmt = parseFloat(totalAmt - gvAmount).toFixed(2);
        let cashamt = parseFloat(totalAmt - CardAmount - UPIAmount).toFixed(2);

        setFormData((prevData) => ({
            ...prevData,
            TotalQuantity: Quantity,
            TotalAmount: Amount.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            GrandTotal: parseFloat(totalAmt).toFixed(2),
            CashAmount: parseFloat(cashamt).toFixed(2),
            GVAmount: gvAmount.toFixed(2),
            CardAmount: CardAmount.toFixed(2),
            UPIAmount: UPIAmount.toFixed(2),
            CashDiscount: 0,
            ModifiedBy: userId,
        }));
    };

    const [itemdetails, setItemDetails] = useState([]);
    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        setModalData({
            ...modalData,
            ItemName: selectedOption ? selectedOption.label : '',
            ItemId: selectedOption ? selectedOption.value : '',
        });

        // Use Array.prototype.find() to find the rate
        const selectedItemId = selectedOption ? selectedOption.value : '';

        // Find the matching item in the original sale bill to get the allowed return quantity
        const saleItem = saleItemdeatils.find((item) => item.ItemId === selectedItemId);
        const saleQty = saleItem ? parseFloat(saleItem.Quantity) || 0 : 0;

        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            let quantity = parseFloat(modalData.Quantity) || 0;;
            let rate = parseFloat(selectedItemDetail.MRP.toFixed(2)) || 0;
            let gstrate = parseFloat(selectedItemDetail.GSTRate.toFixed(2)) || 0;
            let discountPercentage = parseFloat(selectedItemDetail.DiscountPercentage.toFixed(2)) || 0;

            let amount = (quantity * rate).toFixed(2);
            let discamt = ((rate * discountPercentage) / 100).toFixed(2)
            let grate = (rate - discamt).toFixed(2);
            let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);
            const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

            let cgst = 0;
            let sgst = 0;
            let igst = 0;

            if (!formData.GSTNumber) {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            } else {
                const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                if (gstNumberPrefix !== branchstate) {
                    igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                } else {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                }
            }

            const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

            setModalData({
                ...modalData,
                Rate: selectedItemDetail.MRP.toFixed(2), // Assuming Rate is a number
                GSTRate: selectedItemDetail.GSTRate.toFixed(2),
                HSNCode: selectedItemDetail.HSNCode,
                DiscountPercentage: selectedItemDetail.DiscountPercentage.toFixed(2),
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: amount,
                DiscountAmount: parseFloat(discamt).toFixed(2),
                TaxableAmount: parseFloat(taxableamount).toFixed(2),
                CGSTAmount: parseFloat(cgst).toFixed(2),
                SGSTAmount: parseFloat(sgst).toFixed(2),
                IGSTAmount: parseFloat(igst).toFixed(2),
                TotalAmount: parseFloat(totalAmount).toFixed(2),
                saleQty: saleQty,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '0.00',
                GSTRate: '0.00',
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                HSNCode: '',
                DiscountPercentage: '',
                saleQty: saleQty,
            });
        }
    };

    const [isValid, setIsValid] = useState(true);
    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        const intValue = parseInt(value, 10);

        if (modalData.saleQty > 0 && intValue > modalData.saleQty) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }

        setModalData({
            ...modalData,
            [name]: value,
        });

        let quantity = parseFloat(value) || 0;
        let rate = parseFloat(modalData.Rate) || 0;
        let gstrate = parseFloat(modalData.GSTRate) || 0;
        let discountPercentage = parseFloat(modalData.DiscountPercentage) || 0;

        let amount = (quantity * rate).toFixed(2);
        let discamt = ((rate * discountPercentage) / 100).toFixed(2)
        let grate = (rate - discamt).toFixed(2);
        let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
        const taxableamount = (quantity * salerate).toFixed(2);
        const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

        let cgst = 0;
        let sgst = 0;
        let igst = 0;

        if (!formData.GSTNumber) {
            cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
        } else {
            const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

            if (gstNumberPrefix !== branchstate) {
                igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
            } else {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            }
        }

        const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

        setModalData({
            ...modalData,
            Quantity: quantity,
            Amount: amount,
            DiscountAmount: parseFloat(discamt).toFixed(2),
            TaxableAmount: parseFloat(taxableamount).toFixed(2),
            CGSTAmount: parseFloat(cgst).toFixed(2),
            SGSTAmount: parseFloat(sgst).toFixed(2),
            IGSTAmount: parseFloat(igst).toFixed(2),
            TotalAmount: parseFloat(totalAmount).toFixed(2),
        });
    };


    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
        setSelectedOption(null); // Clear AsyncSelect
        fetchOptions('');
    };


    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    const [selectedOption, setSelectedOption] = useState(null);
    const handleInputChange = (newValue) => newValue;
    const handleInputBillChange = (newValue) => newValue;
    const [selectedBillOption, setSelectedBillOption] = useState(null);

    const [saleData, setSaleData] = useState([]);
    const [saleItemdeatils, setSaleItemeatils] = useState([]);

    const handleBillSelect = (selectedOption) => {
        setSelectedBillOption(selectedOption);
        const selectedItemId = selectedOption.value;
        const selectedSbill = sbillOptions.find((itemDetail) => itemDetail.Id === selectedItemId);

        fetchData('SaleApi', `/${selectedItemId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setSaleData(response.response_data.Sale);
                    setSaleItemeatils(response.response_data.SaleDetails);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });

        const CustomerName = selectedSbill?.CustomerName ?? '';
        const CustomerAddress = selectedSbill?.CustomerAddress ?? '';
        const GSTNumber = selectedSbill?.GSTNumber ?? '';
        const BillDetails = selectedSbill?.BillDetails ?? '';
        const BillNumber = selectedSbill?.BillNumber ?? '';
        const BillDate = selectedSbill?.BillDate ?? '';
        const ContactNumber = selectedSbill?.ContactNumber ?? '';


        setFormData((prevData) => ({
            ...prevData,
            CustomerName: CustomerName,
            CustomerAddress: CustomerAddress,
            GSTNumber: GSTNumber,
            ContactNumber: ContactNumber,
            SaleBillNumber: BillNumber,
            SaleBillDate: BillDate,
            CreatedBy: userId,
        }));
        
    };


    const handleChangeDrop = (selectedOption) => {
        setSelectedOption(selectedOption);

        // Find the matching item in the original sale bill to get the allowed return quantity
        const saleItem = saleItemdeatils.find((item) => item.ItemId === selectedOption.value);
        const saleQty = saleItem ? parseFloat(saleItem.Quantity) || 0 : 0;

        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedOption.value);
        console.log(selectedOption.value);
        console.log(itemdetails);
        //const selectedItemDetail = saleItemdeatils.find((itemDetail) => itemDetail.Id === selectedOption.value);
        if (selectedItemDetail) {

            let quantity = parseFloat(modalData.Quantity) || 0;;
            let rate = parseFloat(selectedItemDetail.MRP.toFixed(2)) || 0;
            //let rate = parseFloat(selectedItemDetail.Rate.toFixed(2)) || 0;
            let gstrate = parseFloat(selectedItemDetail.GSTRate.toFixed(2)) || 0;
            let discountPercentage = parseFloat(selectedItemDetail.DiscountPercentage.toFixed(2)) || 0;

            let amount = (quantity * rate).toFixed(2);
            let discamt = ((rate * discountPercentage) / 100).toFixed(2)
            let grate = (rate - discamt).toFixed(2);
            let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);
            const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

            let cgst = 0;
            let sgst = 0;
            let igst = 0;

            if (!formData.GSTNumber) {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            } else {
                const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                if (gstNumberPrefix !== branchstate) {
                    igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                } else {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                }
            }

            const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

            setModalData({
                ...modalData,
                Rate: selectedItemDetail.MRP.toFixed(2), // Assuming Rate is a number
                GSTRate: selectedItemDetail.GSTRate.toFixed(2),
                HSNCode: selectedItemDetail.HSNCode,
                DiscountPercentage: selectedItemDetail.DiscountPercentage.toFixed(2),
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: amount,
                DiscountAmount: parseFloat(discamt).toFixed(2),
                TaxableAmount: parseFloat(taxableamount).toFixed(2),
                CGSTAmount: parseFloat(cgst).toFixed(2),
                SGSTAmount: parseFloat(sgst).toFixed(2),
                IGSTAmount: parseFloat(igst).toFixed(2),
                TotalAmount: parseFloat(totalAmount).toFixed(2),
                saleQty: saleQty,
            });
        }
    };

    const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);

    const openModalEdit = () => {
        setIsModalOpenEdit(true);
    };

    const closeModalEdit = () => {
        setIsModalOpenEdit(false);
    };




    return (
        <Fragment>
            <div className="pg-container">

                {/* â”€â”€ Header â”€â”€ */}
                <div className="pg-header">
                    <h5 className="pg-title">Sale Return Create</h5>
                    <div className="pg-header-actions">
                        <div className="pg-action-row">
                            <button className="pg-btn pg-btn-outline" onClick={openModalEdit}>
                                <ReceiptIcon /> Sale Details
                            </button>
                            <button className="pg-btn pg-btn-primary" onClick={toggleModal}>
                                <AddIcon /> Add Item
                            </button>
                            <button className="pg-btn pg-btn-success" onClick={handleSubmit} disabled={isLoading}>
                                <DoneIcon /> {isLoading ? <CircularProgress size={14} color="inherit" /> : 'SAVE'}
                            </button>
                            <Link to="/SaleReturnIndex" className="pg-btn pg-btn-danger">
                                <CloseIcon /> CANCEL
                            </Link>
                        </div>
                    </div>
                </div>

                {errorMessage  && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
                {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

                <div className="pg-card">
                    {/* â”€â”€ Row 1 â”€â”€ */}
                    <div className="pg-hpanel">
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Customer Name <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="text"
                                placeholder="Customer Name"
                                name="CustomerName"
                                value={formData.CustomerName || ''}
                                onChange={handleChange} />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Bill Date <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="date"
                                name="BillDate"
                                value={formatDateForInput(formData.BillDate)}
                                onChange={handleChange}
                                readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Bill Number <span className="req">*</span></span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                placeholder="Bill Number"
                                name="BillNumber"
                                value={formData.BillNumber || ''}
                                onChange={handleChange}
                                readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 80px' }}>
                            <span className="pg-hcell-label">Total Qty</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                name="TotalQuantity"
                                value={formData.TotalQuantity || ''}
                                onChange={handleChange}
                                readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 90px' }}>
                            <span className="pg-hcell-label">Addt'l Disc %</span>
                            <input className="pg-hcell-input text-right" type="number"
                                placeholder="Disc %"
                                name="AdditionalDiscountPercentage"
                                value={formData.AdditionalDiscountPercentage || ''}
                                onChange={handleChange} />
                        </div>
                    </div>

                    {/* â”€â”€ Row 2 â”€â”€ */}
                    <div className="pg-hpanel" style={{ marginTop: 8 }}>
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Address</span>
                            <input className="pg-hcell-input" type="text"
                                placeholder="Address"
                                name="CustomerAddress"
                                value={formData.CustomerAddress || ''}
                                onChange={handleChange} />
                        </div>
                        <div className="pg-hcell" style={{ flex: '2 1 0' }}>
                            <span className="pg-hcell-label">GST Number</span>
                            <input className="pg-hcell-input" type="text"
                                placeholder="GST Number"
                                name="GSTNumber"
                                value={formData.GSTNumber || ''}
                                onChange={handleChange} />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Sale Bill No <span className="req">*</span></span>
                            <AsyncSelect
                                cacheOptions
                                loadOptions={fetchBillOptions}
                                onInputChange={handleInputBillChange}
                                onChange={handleBillSelect}
                                value={selectedBillOption}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                    control: (b) => ({ ...b, minHeight: 28, height: 28, fontSize: 11, borderColor: 'rgba(200,212,224,0.8)', borderRadius: 5 }),
                                    valueContainer: (b) => ({ ...b, padding: '0 8px' }),
                                    indicatorsContainer: (b) => ({ ...b, height: 28 }),
                                    menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                                    menu: (b) => ({ ...b, fontSize: 11 }),
                                    option: (b) => ({ ...b, fontSize: 11, padding: '4px 10px' }),
                                    singleValue: (b) => ({ ...b, fontSize: 11 }),
                                }}
                            />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Sale Bill Date <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="date"
                                name="SaleBillDate"
                                value={formatDateForInput(formData.SaleBillDate)}
                                onChange={handleChange} />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Sales Man <span className="req">*</span></span>
                            <select className="pg-hcell-select"
                                value={selectedSalesMan}
                                onChange={(e) => {
                                    const v = e.target.value;
                                    setSelectedSalesMan(v);
                                    setFormData(p => ({ ...p, SalesManId: v }));
                                }}>
                                <option value="">Select Sales Man</option>
                                {dropdownSalesManOptions.map(c => <option key={c.Id} value={c.Id}>{c.Name}</option>)}
                            </select>
                        </div>
                    </div>
                    {/* Add Item inline panel */}
                    {isModalOpen && (
                        <div className="pg-item-bar" style={{ marginTop: 8, marginBottom: 8 }}>
                            {errorMessageModel && <div className="pg-alert pg-alert-error" style={{ width: '100%' }}>{errorMessageModel}</div>}
                            <div className="pg-field" style={{ flex: '2 1 220px' }}>
                                <span className="pg-label">Item Name</span>
                                <AsyncSelect
                                    cacheOptions
                                    loadOptions={fetchOptions}
                                    onInputChange={handleInputChange}
                                    onChange={handleChangeDrop}
                                    value={selectedOption}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        control: (b) => ({ ...b, minHeight: 31, height: 31, fontSize: 11, borderColor: 'rgba(200,212,224,0.7)', borderRadius: 6, marginTop: 6 }),
                                        valueContainer: (b) => ({ ...b, padding: '0 10px' }),
                                        indicatorsContainer: (b) => ({ ...b, height: 31 }),
                                        menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                                        menu: (b) => ({ ...b, fontSize: 11 }),
                                        option: (b) => ({ ...b, fontSize: 11, padding: '4px 10px' }),
                                        singleValue: (b) => ({ ...b, fontSize: 11 }),
                                        input: (b) => ({ ...b, fontSize: 11 }),
                                    }}
                                />
                            </div>
                            <div className="pg-field narrow">
                                <span className="pg-label">Quantity</span>
                                <input className="pg-input text-right" type="number"
                                    name="Quantity" placeholder="Qty"
                                    value={modalData.Quantity}
                                    onChange={handleModalInputChange}
                                    min={1} max={modalData.saleQty || undefined} />
                                {!isValid && <span style={{ color: 'red', fontSize: 11 }}>Exceeds sale bill qty ({modalData.saleQty})</span>}
                            </div>
                            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', paddingBottom: 2 }}>
                                <button className="pg-btn pg-btn-success" onClick={saveModalData}>
                                    <DoneIcon /> Add
                                </button>
                                <button className="pg-btn pg-btn-danger" onClick={toggleModal}>
                                    <CloseIcon /> Cancel
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Items table */}
                    <div className="pg-invoice-table-wrap" style={{ marginTop: 12 }}>
                        <table className="pg-invoice-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Item Name</th>
                                    <th className="right">Qty</th>
                                    <th className="right">MRP</th>
                                    <th className="right">Disc %</th>
                                    <th className="right">Total</th>
                                    <th className="right">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoicedeatils.length === 0
                                    ? <tr><td colSpan={7} style={{ textAlign: 'center', color: '#94a3b8', padding: 14 }}>No items added yet.</td></tr>
                                    : invoicedeatils.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: 'center', width: 36 }}>{index + 1}</td>
                                            <td style={{ width: '35%' }}>{item.ItemName}</td>
                                            <td className="right">{item.Quantity}</td>
                                            <td className="right">{item.Rate}</td>
                                            <td className="right">{item.DiscountPercentage}</td>
                                            <td className="right" style={{ fontWeight: 700 }}>{item.TotalAmount}</td>
                                            <td className="right">
                                                <IconButton size="small" onClick={() => removeRecord(index)}>
                                                    <DeleteIcon style={{ color: 'red', fontSize: 18 }} />
                                                </IconButton>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>

                    {/* Remarks full width */}
                    <div style={{ marginTop: 8, marginBottom: 8 }}>
                        <span className="pg-hcell-label">Remarks</span>
                        <input className="pg-hcell-input" type="text"
                            placeholder="Remarks"
                            name="Remarks"
                            value={formData.Remarks || ""}
                            onChange={handleChange}
                            style={{ marginTop: 3, width: "100%", boxSizing: "border-box" }} />
                    </div>
                    {/* Totals Panel */}
                    <div className="pg-totals-panel">
                        {/* Left: summary */}
                        <div className="pg-totals-left">
                            <div className="pg-totals-summary">
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Amount</span>
                                    <span className="pg-tsum-value">{formData.TotalAmount || '0.00'}</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Discount</span>
                                    <span className="pg-tsum-value">{formData.DiscountAmount || '0.00'}</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Cash Disc</span>
                                    <span className="pg-tsum-value">{formData.CashDiscount || '0.00'}</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">GV Amount</span>
                                    <input className="pg-tsum-input" type="text"
                                        name="GVAmount"
                                        value={formData.GVAmount || ''}
                                        onChange={handleChange} />
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Net Amount</span>
                                    <span className="pg-tsum-value">{formData.TaxableAmount || '0.00'}</span>
                                </div>
                            </div>
                        </div>

                        <div className="pg-totals-divider" />

                        {/* Right: GST + Grand Total + Payments */}
                        <div className="pg-totals-right">
                            <div className="pg-totals-gst-row">
                                <div className="pg-tgst-cell">
                                    <span className="pg-tgst-label">CGST</span>
                                    <span className="pg-tgst-value">{formData.CGSTAmount || '0.00'}</span>
                                </div>
                                <div className="pg-tgst-cell">
                                    <span className="pg-tgst-label">SGST</span>
                                    <span className="pg-tgst-value">{formData.SGSTAmount || '0.00'}</span>
                                </div>
                                <div className="pg-tgst-cell">
                                    <span className="pg-tgst-label">IGST</span>
                                    <span className="pg-tgst-value">{formData.IGSTAmount || '0.00'}</span>
                                </div>
                                <div className="pg-tgst-cell">
                                    <span className="pg-tgst-label">Round Off</span>
                                    <span className="pg-tgst-value">{formData.RoundOff || '0.00'}</span>
                                </div>
                            </div>

                            <div className="pg-grand-total-bar">
                                <span className="pg-gt-label">Grand Total</span>
                                <span className="pg-gt-value">{formData.GrandTotal || '0.00'}</span>
                            </div>

                            <div className="pg-totals-pay-row">
                                <div className="pg-tpay-cell">
                                    <label className="pg-tpay-label">Cash <span className="req">*</span></label>
                                    <input className={`pg-tpay-input${formData.CashAmount < 0 ? ' cash-negative' : ''}`}
                                        type="text" name="CashAmount"
                                        value={formData.CashAmount || ''}
                                        onChange={handleChange}
                                        readOnly />
                                </div>
                                <div className="pg-tpay-cell">
                                    <label className="pg-tpay-label">Card <span className="req">*</span></label>
                                    <input className="pg-tpay-input" type="text"
                                        name="CardAmount"
                                        value={formData.CardAmount || ''}
                                        onChange={handleChange} />
                                </div>
                                <div className="pg-tpay-cell">
                                    <label className="pg-tpay-label">UPI / RTGS / Other <span className="req">*</span></label>
                                    <input className="pg-tpay-input" type="text"
                                        name="UPIAmount"
                                        value={formData.UPIAmount || ''}
                                        onChange={handleChange} />
                                </div>
                            </div>

                            {(formData.CardAmount > 0 || formData.UPIAmount > 0) && (
                                <div className="pg-tpay-extra-row">
                                    {formData.CardAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <label className="pg-tpay-label">Card Type</label>
                                            <select className="pg-tpay-select"
                                                value={selectedCardType}
                                                onChange={(e) => {
                                                    const v = e.target.value;
                                                    setSelectedCardType(v);
                                                    setFormData(p => ({ ...p, CardType: v }));
                                                }}>
                                                <option value="">Select Card Type</option>
                                                {dropdownCardTypeOptions.map(c => <option key={c.Id} value={c.Id}>{c.Name}</option>)}
                                            </select>
                                        </div>
                                    )}
                                    {formData.CardAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <label className="pg-tpay-label">Card Number</label>
                                            <input className="pg-tpay-input" type="text"
                                                name="CardNumber"
                                                value={formData.CardNumber || ''}
                                                onChange={handleChange} />
                                        </div>
                                    )}
                                    {formData.UPIAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <label className="pg-tpay-label">UPI / RTGS / Other No.</label>
                                            <input className="pg-tpay-input" type="text"
                                                name="UPINumber"
                                                value={formData.UPINumber || ''}
                                                onChange={handleChange} />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* â”€â”€ Sale Bill Details Modal â”€â”€ */}
                <Modal open={isModalOpenEdit} onClose={closeModalEdit}>
                    <div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300, background: 'rgba(15,23,42,0.45)' }}>
                        <div className="pg-card" style={{ width: '98%', maxWidth: 1100, maxHeight: '90vh', overflowY: 'auto' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                <h5 className="pg-title">Sale Bill Item Details</h5>
                                <button onClick={closeModalEdit} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#64748b' }}>&times;</button>
                            </div>
                            <div className="pg-invoice-table-wrap">
                                <table className="pg-invoice-table">
                                    <thead>
                                        <tr>
                                            <th>Item Name</th>
                                            <th className="right">Qty</th>
                                            <th className="right">MRP</th>
                                            <th className="right">Disc %</th>
                                            <th className="right">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {saleItemdeatils.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ width: '45%' }}>{item.ItemName}</td>
                                                <td className="right">{item.Quantity}</td>
                                                <td className="right">{item.Rate ? item.Rate.toFixed(2) : '0.00'}</td>
                                                <td className="right">{item.DiscountPercentage ? item.DiscountPercentage.toFixed(2) : '0.00'}</td>
                                                <td className="right">{item.TotalAmount ? item.TotalAmount.toFixed(2) : '0.00'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Modal>

                <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
            </div>
        </Fragment>
    );
};

export default SaleReturnCreate;



